import * as React from "react";

export const PendingOperationsContext =
    React.createContext<IPendingOperationsContext>({
        anyPendingOperations: () => false,
    });

export interface IPendingOperationsContext {
    anyPendingOperations: () => boolean;
}
